import React from "react"
import { FormattedMessage } from "react-intl"
import Icon from "../common/icon/icon.component"
import PricingTableTotals from "../common/pricing/totals.component.jsx"
import QuoteCurrency from "../common/quote/currency.component"
import QuoteIdentifier from "../common/quote/identifier.component"
import { GlobalHelper } from "../indexImports"
import PricingTableContent from "../pricing/PricingTableContentComponent.jsx"
import { LocationDto } from "../state/location/Location"
import { PaymentTransactionDto } from "../state/payment/PaymentTransaction"
import { GroupDto } from "../state/pricing/Group"
import { PricingRowDto } from "../state/pricing/PricingRow"
import { PricingTotalDto } from "../state/pricing/PricingTotals"

type OwnProps = {
    children: React.ReactNode,
    identifierId: string,
    currency: string,
    identifier: string,
    orderId: string,
    items: PricingRowDto[],
    totals: PricingTotalDto[],
    groups: GroupDto[],
    depositAmount: string,
    depositType: string,
    depositRatio: number,
    contactId: string,
    projectId: string,
    location: LocationDto,
    payments: PaymentTransactionDto,
    openEditOrderItemModal: () => void,
    handleAddProductLink: () => void,
    addGroup: () => void,
    refreshOrder: () => void,
    tableId: string,
    documentStatus: string,
}

const AddProducts = (props: OwnProps) => {
    return (
        <div >
            <PricingTableContent
                tableId={props.tableId}
                projectId={props.projectId}
                objectId={props.orderId}
                mainObject={"orders"}
                mainObjectItem={"order-items"}
                onUpdate={() => {
                    props.refreshOrder()
                }}
                currency={props.currency}
                location={props.location}
                allowEdit={true}
                sortable={true}
                showInventoryDetails={true}
                onEditLinkClick={props.openEditOrderItemModal}
                documentStatus={props.documentStatus}
            />

            <div className="col-12 w-100 quote-add-product" onClick={props.handleAddProductLink}>
                <a href="#" className="btn btn-link btn-add-product">
                    <FormattedMessage
                        id="order.edit.add_product_btn"
                        defaultMessage="Add a product"
                    />
                </a>
            </div>

            <div className={"row mb-3"}>
                <div className={"col-md-4"}>
                    <div className={"mt-4 pt-2 mb-0 w-100"}>
                        <button className={"btn btn-outline-primary"} onClick={props.addGroup}>
                            <Icon value={"layer-group"} className={"mr-1"} />
                            <FormattedMessage
                                id="invoice.edit.add_group_btn"
                                defaultMessage="Add a group"
                            />
                        </button>
                    </div>
                    {GlobalHelper.getEnabledCurrenciesSelectOptions().length > 1 ?
                        <div className={"pt-3 w-100"}>
                            <QuoteCurrency
                                className={"mr-2 w-100"}
                                objectId={props.orderId}
                                mainObject={"orders"}
                                editable={true}
                                currency={props.currency}
                                onChange={props.refreshOrder}
                            />
                        </div> : ""}
                    <div className={"pt-3 w-100"}>
                        <QuoteIdentifier
                            className={"mr-2 w-100"}
                            identifierId={props.identifierId}
                            identifier={props.identifier}
                            editable={true}
                            onChange={props.refreshOrder}
                        />
                    </div>
                </div>
                <div className={"col-md-8 pb-3"}>
                    <PricingTableTotals
                        totalClassName={"col-lg-8 col-md-12"}
                        mainObjectId={props.orderId}
                        allowEdit={true}
                        rows={props.items}
                        mainObject={"orders"}
                        objectId={props.orderId}
                        contactId={props.contactId}
                        showLoyalty={false}
                        depositType={props.depositType}
                        onChange={props.refreshOrder}
                        payments={props.payments}
                        depositAmount={props.depositAmount}
                        depositRatio={props.depositRatio}
                    />
                </div>
            </div>
        </div>
    )
}

export default AddProducts


// WEBPACK FOOTER //
// ./src/order/AddProducts.tsx